import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarHiddenLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSidebarHiddenLeftWide"><Path fillRule="evenodd" clipRule="evenodd" d="M19.5 4C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5C2 5.11929 3.11929 4 4.5 4H19.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5V16.5C5 16.7761 5.22386 17 5.5 17C5.77614 17 6 16.7761 6 16.5V7.5C6 7.22386 5.77614 7 5.5 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarHiddenLeftWide;
